module.exports = __webpack_public_path__ + "88fe077b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/routes/home/img/blog/blog4.jpg
// module id = 725
// module chunks = 1